import styled from 'styled-components'

export const WorkplaceHealthPromotion = styled.div`
  margin-bottom: 20px;

  .grid > div:first-child {
    padding-left: 0;
  }

  img {
    max-height: 240px;
  }

  p.PIP {
    margin-top: 12px;
  }
`
